<template>
  <div class="page-component-wrapper">
    <grid :config="gridConfig"/>
    <modal-new :config="{id: gridConfig.id, api: 'RFQTypes/Get/'}"/>
  </div>
</template>

<script>
import gridConfig from './GridConfig'

export default {
  name: 'RFQIndex',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'modal-new': () => import(/* webpackChunkName: 'RFQTypes' */ './ModalNew')
  },
  data () {
    return {
      gridConfig: gridConfig
    }
  }
}
</script>
